<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="secondary" height="80">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
          <b>Wählen Sie den zu verknüpfenden Subprozess:</b>
          <v-select
          style="height:60px; margin-left:10px"
          :items="availableProcesses"
          item-text="fileName"
          label="Verfügbare Prozesse"
          outlined
          @input="selectProcess"
          v-model="selectedProcess"
          return-object
        ></v-select>
        <v-btn dark text @click="freeConnectSubprocess" outlined>Ohne verknüpfung fortfahren</v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="connectSubprocess" class="mt-5">Verknüpfen</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div v-if="loaded">
        <BpmnViewer v-if="dialog" ref="bpmnViewer" :diagramXML="selectedProcessXml" style="margin-top: 64px" />  
      </div>
      <div v-else>
        <p v-if="availableProcesses.length == 0" style="text-align-last: center; margin: 10px; font-size:1.25rem;">Es sind leider keine Prozesse zum verknüpfen vorhanden. Fügen Sie neue Prozesse zur Plattform hinzu um diese verknüpfen zu können.</p>
        <p v-else style="text-align-last: center; margin: 10px; font-size:1.25rem;">Prozess auswählen um Vorschau anzuzeigen</p>    
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import processlistService from '@/pages/ProcessList/processlist-service.js'
import processModelingService from "@/pages/ProcessModeling/process-modeling-service.js";
import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
export default {
  name: "SubprocessDialog",
  components:{
    BpmnViewer
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      availableProcesses: [],
      loaded: false,
      selectedProcess: null,
      selectedProcessXml: null
    }
  },
  computed: {
    processUUID() {
      return this.$route.params.uuid;
    }
  },
  methods: {
    fetchAvailableProcesses(){
      return processlistService.retrieveProcessNames();
    },
    selectProcess(){
      if(this.selectedProcess == null) return;
      processModelingService.getProcessXml(this.selectedProcess.uuid).then(res => {
        this.selectedProcessXml = res.data;
        this.loaded = true;
      })
    },
    open(uuid) {
      this.selectedProcess = null;
      this.selectedProcessXml = null;
      this.fetchAvailableProcesses().then(res => {
        this.availableProcesses = res.data;
        this.availableProcesses = this.availableProcesses.filter(elem => elem.uuid != this.processUUID);
        if(uuid) {
          this.selectedProcess = this.availableProcesses.filter(elem => elem.uuid == uuid)[0];
          this.selectProcess();
        }
        this.dialog = true;
      }).catch(e => console.log(e));
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    connectSubprocess() {
      this.resolve(this.selectedProcess);
      this.dialog = false;
    },
    freeConnectSubprocess(){
      this.resolve(null);
      this.dialog = false;
    },
    closeDialog(){
      this.reject(false);
      this.dialog = false;
    }
  }
};
</script>

<style>
.dialog {
  flex-grow: 0;
  padding: 20px;
  background-color: #fff;
}

.header{
  width: 100%;
  height: 50px;
  margin: 0px;
}
.description{
  display:inline-block;
  width: calc(60% - 5px);
  height: 400px;
  margin: 15px 5px 0 0;
}
.modelList{
  display:inline-block;
  width: calc(40% - 15px);
  height: 400px;
  margin: 5px 0 0 15px;
  border-left: 2px solid var(--v-primary-base);
}
.elementDivider{

  margin: 1px;
  border: 0.5px solid var(--v-primary-base);
}
</style>